const KEY = 'couplespace:last-chat-id';

export function getLastChatId(): string | null {
  if (typeof localStorage === 'undefined') {
    return null;
  }
  return localStorage.getItem(KEY);
}

export function setLastChatId(id: string): void {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(KEY, id);
  }
}
